/**
 * This module keeps track of the connectivity status of kmoffline. 
 * 
 * It keeps track of:
 *          * front-end internet connectivity
 *          * back-end internet connectivity
 *          * back-end hservice connectivity
 * 
 * The module is designed to be as responsive a possible while limiting the 
 * bandwidth used as much as possible. For this, it pairs with 
 * browser-tab-activity.service (through window event listener) to know when
 * the application is under active use and increases the check frequency when
 * this is the case.
 * 
 * While user is logged in, we want to use the hServiceConnectivity.jsp to 
 * check backend connectivity because we don't want to impact session timeout.
 * 
 * When the user is logged out however we can make direct calls to TODO.action
 * which should be a public backend url. This will allow a more direct access
 * to the information.
 * 
 * ----------
 *    TBD:
 * ----------
 * If the front-end has no internet connectivity, the backend and hservice 
 * should normally not have any either. This should be a faster way to 
 * pre-check. However, for development environment where hservice is on the 
 * same host as the kmoffline, this may not work.
 */

//---- components ---------
//---- mixins -------------
//---- services -----------
import kmofflineService from "./kmoffline.service.js";
//---- other --------------
import store from '@/app/store/index.js'
//---- 3rd-parties --------

class KMOfflineConnectivityService {

    debug = false;
    LOGGED_IN_ACTIVE_INTERVAL = 5000;
    LOGGED_IN_INACTIVE_INTERVAL = 20000;
    LOGGED_OUT_ACTIVE_INTERVAL = 1000;
    LOGGED_OUT_INACTIVE_INTERVAL = 30000;

    #intervalHandle;
    #userActiveListener;

    setup() {
        if (this.debug)
            console.log("kmoffline-connectivity.service setup")
        
        this.startInterval();

        let newUserActivityListener = this.onUserActivityChange.bind(this);
        window.removeEventListener("user-activity-status-change", this.#userActiveListener);
        window.addEventListener("user-activity-status-change", newUserActivityListener);
        this.#userActiveListener = newUserActivityListener;

    }

    tearDown() {
        if (this.debug)
            console.log("kmoffline-connectivity.service tearDown")

        window.removeEventListener("user-activity-status-change", this.#userActiveListener);
        this.#userActiveListener = null;

        this.stopInterval();
    }

    //-------------------------------------------------------------------------

    onUserActivityChange(e) {
        if (this.debug)
            console.log("User active: " + e.detail.userActive);
        this.startInterval(e.detail.userActive);
    }
    
    //-------------------------------------------------------------------------

    // start a timer that will periodically check for connectivity
    // returns the interval handler
    startInterval(isUserActive) {
        if (!kmofflineService.isReplica()) {
            if (this.debug)
                console.log("not a replica, don't start interval")
            return null;
        }

        let interval;
        if (store.getters["auth/loggedIn"])
            interval = isUserActive ? this.LOGGED_IN_ACTIVE_INTERVAL : this.LOGGED_IN_INACTIVE_INTERVAL;
        else
            interval = isUserActive ? this.LOGGED_OUT_ACTIVE_INTERVAL : this.LOGGED_OUT_INACTIVE_INTERVAL;

        const checkConnectivityTask = () => {
            if (!kmofflineService.isReplica())
              return;

            if (this.debug)
                console.log("check connectivity")

            if (!navigator.onLine) {
                store.dispatch("kmOffline/updateConnectedState", {
                    browserConnectivity: false,
                    backendInternetConnectivity: false,
                    hServiceConnectivity: false
                });
              return;
            }
            kmofflineService.checkConnectivity(interval);
        };
      
        // check connectivity status and keep that up to date in vuex
        // check connectivity immediately, and then every 30 seconds 
        checkConnectivityTask();

        if (this.debug)
            console.log("Starting replica status check with interval: " + interval)

        // make sure we don't have 2 running at the same time
        this.stopInterval();

        this.#intervalHandle = setInterval(checkConnectivityTask, interval);
    }

    stopInterval() {
        if (this.#intervalHandle)
            clearInterval(this.#intervalHandle);
        this.#intervalHandle = null;
    }
}

export default new KMOfflineConnectivityService();